export enum Subscriptions {
  Old = 'old',
  Basic = 'basic',
  Basic3 = 'basic_3',
  Local = 'local',
  Pro = 'pro',
  Premium = 'premium',
  TrialBasic = 'trial_basic',
  TrialPro = 'trial_pro',
  TrialPremium = 'trial_premium',
  RikSilver = 'rik_silver',
  RikGolden = 'rik_golden',
  Custom = 'custom',
  CustomPro6 = 'custom_pro_6',
  CustomPro12 = 'custom_pro_12',
  CustomPremium6 = 'custom_premium_6',
  CustomPremium12 = 'custom_premium_12',
  CustomRikSilver12 = 'custom_rik_silver_12',
  CustomRikGolden12 = 'custom_rik_golden_12',
  Premium3 = 'premium_3',
  Premium12 = 'premium_12',
  Pro3 = 'pro_3',
  TrialPro1 = 'trial_pro_1',
  TrialPremium1 = 'trial_premium_1',
  TrialPro3 = 'trial_pro_3',
  TrialPremium3 = 'trial_premium_3',
  Pro12 = 'pro_12',
  Premium6 = 'premium_6',
  Pro6 = 'pro_6',
  Premium1 = 'premium_1',
  RikSilver12 = 'rik_silver_12',
  RikGolden12 = 'rik_golden_12'
}

export const proOrPremiumSub = [
  Subscriptions.Pro,
  Subscriptions.Pro3,
  Subscriptions.Pro6,
  Subscriptions.Pro12,
  Subscriptions.Premium,
  Subscriptions.Premium1,
  Subscriptions.Premium3,
  Subscriptions.Premium6,
  Subscriptions.Premium12,
  Subscriptions.TrialPro,
  Subscriptions.Premium,
  Subscriptions.TrialPremium,
  Subscriptions.RikGolden,
  Subscriptions.RikSilver,
  Subscriptions.CustomPro6,
  Subscriptions.CustomPro12,
  Subscriptions.CustomPremium6,
  Subscriptions.CustomPremium12,
  Subscriptions.CustomRikSilver12,
  Subscriptions.CustomRikGolden12,
  Subscriptions.TrialPro1,
  Subscriptions.TrialPremium1,
  Subscriptions.TrialPro3,
  Subscriptions.TrialPremium3,
  Subscriptions.RikGolden12,
  Subscriptions.RikSilver12
];
export const PremiumSub = [
  Subscriptions.CustomPremium6,
  Subscriptions.CustomPremium12,
  Subscriptions.CustomRikSilver12,
  Subscriptions.CustomRikGolden12,
  Subscriptions.TrialPremium,
  Subscriptions.TrialPremium1,
  Subscriptions.TrialPremium3,
  Subscriptions.Premium,
  Subscriptions.Premium1,
  Subscriptions.Premium3,
  Subscriptions.Premium6,
  Subscriptions.Premium12,
  Subscriptions.RikSilver12,
  Subscriptions.RikGolden12,
  Subscriptions.RikSilver,
  Subscriptions.RikGolden
];
